import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Field, reduxForm, clearSubmitErrors } from 'redux-form';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import history from '../../core/history';
import { closeImportListModal } from '../../actions/modalActions';

import InputFieldComponent from '../Common/FormField/InputFieldComponent';

import validate from './validate';
import submit from './submit';
import messages from '../../locale/messages';

import s from './ImportListing.css';
import bt from '../../components/commonStyle.css';
import MDSpinner from 'react-md-spinner';

import clapGif from "../../../public/SiteImages/clapDogs.gif";
class ImportListingForm extends Component {

  static propTypes = {
    formatMessage: PropTypes.func,
    siteName: PropTypes.string.isRequired,
    spinnerColor: PropTypes.string,
    setIsProcessing: PropTypes.func.isRequired, // Added for modal close control
    isProcessing: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
    closeImportListModal: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      submissionSuccess: false,
      listingId: null,
      submissionError: null,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOkClick = this.handleOkClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this); 
  }

  async handleSubmit(e) {
    e.preventDefault();
    const { handleSubmit, setIsProcessing, dispatch } = this.props;

    this.setState({ submissionError: null });
    setIsProcessing(true); // Disable modal close button and form inputs
    try {
      const response = await handleSubmit(submit)(); // Call redux-form's submit handler
      // Assume submit.js returns { listingId } or similar
      if (response.status == 200) {
        this.setState({
          submissionSuccess: true,
          listingId: response.listingId, // Adjust based on actual response structure
        });
      } else {
        this.setState({
          submissionError: response.message || 'importListingError',
        });
        dispatch(clearSubmitErrors('ImportListingForm'));
      }
    } catch (error) {
      console.log(error);
      this.setState({
        submissionError: "importListingError",
      });
      dispatch(clearSubmitErrors('ImportListingForm'));
      // Re-trigger validation for listingUrl
      dispatch(touch('ImportListingForm', 'listingUrl'));
      console.error('Submission Error:', error);
      // Error message is handled by redux-form's error prop
    } finally {
      setIsProcessing(false); // Re-enable modal close button and form inputs
    }
  }

  handleOkClick() {
    const { listingId } = this.state;
    const { closeImportListModal } = this.props;
    
    if (listingId) {
      closeImportListModal();
      history.push(`/become-a-host/${listingId}/home`);
    }
  }

  handleInputChange() {
    if (this.state.submissionError) {
      this.setState({ submissionError: null });
    }
  }

  render() {
    const { error, handleSubmit, submitting, dispatch, siteName, spinnerColor, isProcessing, invalid } = this.props;
    const { formatMessage } = this.props.intl;
    const { submissionSuccess, submissionError } = this.state;

    return (
      <div>
        {submissionSuccess ? (
          <div className={cx(s.successMessage)}>
            <img
              src={clapGif}
              alt="Loading"
              style={{ maxWidth: '450px', marginTop: '10px', width: '100%' }}
            />
            <p>
              <FormattedMessage {...messages.importListingSuccess} />
            </p>
            <Button
              className={cx(bt.btnPrimary, bt.btnLarge)}
              onClick={this.handleOkClick}
            >
              {formatMessage(messages.importListingOkButton)}
            </Button>
          </div>
        ) : (
          <form onSubmit={this.handleSubmit}>
            <FormGroup className={bt.space3}>
              <Field
                name="listingUrl"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.importListModalInputFieldLable)}
                placeholder={formatMessage(messages.importListModalInputFieldPlaceHolder)}
                inputClass={cx(bt.commonControlInput)}
                disabled={isProcessing || submitting}
              />
            </FormGroup>
            {submissionError && (
              <span className={s.errorMessage}>
                {formatMessage(messages[submissionError])}
              </span>
            )}
            <Button className={cx(bt.btnPrimary, bt.btnBig, bt.space4, bt.importBtnlisting)} block type="submit" disabled={isProcessing || submitting || invalid}>
              {isProcessing || submitting ? (
                <>
                  {formatMessage(messages.importListing)}
                  &nbsp;
                  <MDSpinner singleColor={spinnerColor || '#fff'} size={20} />
                </>
              ) : (
                formatMessage(messages.importListing)
              )}
            </Button>
          </form>
        )}
      </div>
    );
  }

}

ImportListingForm = reduxForm({
  form: 'ImportListingForm', // a unique name for this form
  validate,
  destroyOnUnmount: false
})(ImportListingForm);

const mapState = state => ({
  siteName: state.siteSettings.data.siteName
});

const mapDispatch = {
  closeImportListModal,
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(ImportListingForm)));